import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({
    name: "transformLinkableText",
    standalone: true,
})
export class TransformLinkableText implements PipeTransform{
  constructor(private readonly sanitizer: DomSanitizer){}

    transform(text: string): SafeHtml {
      const urlRegexp = new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+)[^\s]+[^. ,])/,'gi');
      let checkedText = '';
      checkedText = (text.toString() || "").replace(urlRegexp, function(match, space, url) {
        return space + '<a id="' + url + '"' + ' style="color:#007AFF; font-style: italic; text-decoration:underline; cursor:pointer;">' + url + '</a>';
      });   
      let formattedText = this.sanitizer.bypassSecurityTrustHtml(checkedText);
      return formattedText;
    }

}
